/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpCloudSqlTarget } from '../models/GcpCloudSqlTarget';

export class GcpCloudSqlRestoreDestination {
  'gcpCloudSql'?: GcpCloudSqlTarget;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "gcpCloudSql",
      "baseName": "gcpCloudSql",
      "type": "GcpCloudSqlTarget",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpCloudSqlRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

